(function () {
  window.setCookie = function(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  window.addUpsellToCart = function(target) {
    if (target.getAttribute('disabled') === 'disabled') {
      return;
    }
  
    // Get variant ID from either the button's data attribute or the variant selector
    let variantId = target.getAttribute('data-variant-id');
    const productId = target.getAttribute('data-product-id');
    
    // Check if there's a variant selector for this product
    const upsellProduct = target.closest('.upsell-product');
    const variantSelect = upsellProduct ? upsellProduct.querySelector('.upsell-variant-select') : null;
    
    if (variantSelect) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      variantId = selectedOption.value;
      
      // Check if selected variant is still available
      if (selectedOption.dataset.available !== 'true') {
        alert('Sorry, this size is no longer available. Please select a different size.');
        return;
      }
    }
    
    let quantity = 1;

    // Find the closest quantity input if it exists (upsellProduct already defined above)
    const quantityInput = upsellProduct ? upsellProduct.querySelector('.upsell-quantity-input') : null;
    
    if (quantityInput) {
      // Get the value and ensure it's within bounds
      quantity = parseInt(quantityInput.value) || 1;
      const min = parseInt(quantityInput.getAttribute('min')) || 1;
      const max = parseInt(quantityInput.getAttribute('max')) || 1;

      if (quantity < min) {
        quantity = min;
        quantityInput.value = min;
      } else if (quantity > max) {
        quantity = max;
        quantityInput.value = max;
      }
    }

    // Show loading state
    target.style.opacity = '0.5';
    target.setAttribute('disabled', 'disabled');

    // Use the theme's AJAX cart system if available
    if (window.theme && window.theme.ShopifyAPI && window.theme.ShopifyAPI.addItem) {
      // Use theme's AJAX API for seamless cart updates
      window.theme.ShopifyAPI.addItem({
        id: variantId,
        quantity: quantity
      }, function(item) {
        // Success callback - update cart via AJAX
        handleUpsellSuccess(target, item);
      }, function(XMLHttpRequest, textStatus) {
        // Error callback
        handleUpsellError(target, XMLHttpRequest, textStatus);
      });
    } else {
      // Fallback to direct fetch if theme AJAX is not available
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        handleUpsellSuccess(target, data);
      })
      .catch(error => {
        handleUpsellError(target, { responseText: JSON.stringify({ message: error.message }) }, 'error');
      });
    }
  };

  // Handle successful upsell addition
  function handleUpsellSuccess(target, item) {
    // Reset button state
    target.style.opacity = '1';
    target.removeAttribute('disabled');

    // Update cart via AJAX instead of reloading page
    if (window.theme && window.theme.ajaxCart && window.theme.ajaxCart.update) {
      // Use theme's cart update function to refresh cart display
      window.theme.ajaxCart.update(function(cart) {
        // Cart has been updated - show notification or open cart
        if (document.body.classList.contains('dbtfy-cart-notification-enabled')) {
          // Show notification toast if enabled
          if (window.theme && window.theme.NotificationToast) {
            window.theme.helpers.loadComponent('notificationToast', () => {
              window.theme.NotificationToast.init('.dbtfy-cart-notification');
            });
          }
        } else {
          // Open cart drawer/modal
          const cartType = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings.cartType : 'drawer';
          if (cartType === 'drawer' && window.theme && window.theme.RightDrawer) {
            window.theme.RightDrawer.open();
          } else if (cartType === 'modal' && window.theme && window.theme.Modal) {
            window.theme.helpers.loadComponent('cartModal', () => {
              window.theme.CartModal.init();
            });
          }
        }
      });
    } else {
      // Fallback to page reload if AJAX cart is not available
      window.setCookie('show_cart', 'true', 1);
      window.location.reload(true);
    }

    // Dispatch custom event for other scripts to listen to
    document.dispatchEvent(new CustomEvent('upsell:item-added', {
      detail: { item: item, target: target }
    }));
  }

  // Handle upsell addition errors
  function handleUpsellError(target, XMLHttpRequest, textStatus) {
    // Reset button state
    target.style.opacity = '1';
    target.removeAttribute('disabled');

    // Parse error response
    let errorMessage = 'Failed to add product to cart. Please try again.';
    try {
      const errorData = JSON.parse(XMLHttpRequest.responseText || '{}');
      if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.description) {
        errorMessage = errorData.description;
      }
    } catch (e) {
      // Use default error message if parsing fails
    }

    // Show error notification
    if (window.theme && window.theme.helpers && window.theme.helpers.loadComponent) {
      // Try to use theme's notification system
      window.theme.helpers.loadComponent('notificationToast', () => {
        if (window.theme.NotificationToast) {
          // Create a temporary error notification element
          const errorNotification = document.createElement('div');
          errorNotification.className = 'notification notification--error';
          errorNotification.textContent = errorMessage;
          document.body.appendChild(errorNotification);
          
          // Remove after showing
          setTimeout(() => {
            if (errorNotification.parentNode) {
              errorNotification.parentNode.removeChild(errorNotification);
            }
          }, 5000);
        } else {
          alert(errorMessage);
        }
      });
    } else {
      // Fallback to alert
      alert(errorMessage);
    }

    // Dispatch custom event for error handling
    document.dispatchEvent(new CustomEvent('upsell:item-error', {
      detail: { error: XMLHttpRequest, textStatus: textStatus, target: target }
    }));
  }

  // Handle variant selection change
  function handleVariantChange(select) {
    const selectedOption = select.options[select.selectedIndex];
    const productId = select.dataset.productId;
    const upsellProduct = select.closest('.upsell-product');
    
    if (!upsellProduct) return;
    
    // Update price display
    const priceElement = upsellProduct.querySelector('.upsell-price');
    if (priceElement && selectedOption.dataset.price) {
      const price = parseInt(selectedOption.dataset.price);
      const formattedPrice = formatMoney(price);
      priceElement.textContent = formattedPrice;
    }
    
    // Update button's data-variant-id
    const addButton = upsellProduct.querySelector('.upsell-add-btn');
    if (addButton) {
      addButton.setAttribute('data-variant-id', selectedOption.value);
    }
    
    // Update quantity input max based on inventory
    const quantityInput = upsellProduct.querySelector('.upsell-quantity-input');
    if (quantityInput && selectedOption.dataset.inventoryManagement === 'shopify' && selectedOption.dataset.inventoryPolicy === 'deny') {
      const inventory = parseInt(selectedOption.dataset.inventory) || 1;
      quantityInput.setAttribute('max', inventory);
      
      // Adjust current value if it exceeds new max
      const currentVal = parseInt(quantityInput.value) || 1;
      if (currentVal > inventory) {
        quantityInput.value = inventory;
      }
    } else if (quantityInput) {
      quantityInput.setAttribute('max', '10'); // Default max
    }
  }

  // Simple money formatting function (fallback)
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents);
    }
    // Fallback formatting
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars} AUD`;
  }

  // Add handlers for quantity buttons and variant selection
  document.addEventListener('click', function(e) {
    // Plus button handler
    if (e.target.matches('.upsell-quantity .oci-plus')) {
      e.preventDefault();
      const input = e.target.closest('.upsell-quantity').querySelector('.upsell-quantity-input');
      const currentVal = parseInt(input.value) || 1;
      const max = parseInt(input.getAttribute('max')) || 1;
      if (currentVal < max) {
        input.value = currentVal + 1;
      }
    }
    
    // Minus button handler
    if (e.target.matches('.upsell-quantity .oci-minus')) {
      e.preventDefault();
      const input = e.target.closest('.upsell-quantity').querySelector('.upsell-quantity-input');
      const currentVal = parseInt(input.value) || 1;
      const min = parseInt(input.getAttribute('min')) || 1;
      if (currentVal > min) {
        input.value = currentVal - 1;
      }
    }
    
    // Close upsell section handler
    if (e.target.closest('.upsell-products1__close')) {
      const upsellSection = e.target.closest('.upsell-products1');
      if (upsellSection) {
        upsellSection.style.display = 'none';
      }
    }
  });

  // Add handler for variant selection changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('.upsell-variant-select')) {
      handleVariantChange(e.target);
    }
  });

  // Add handler for direct input
  document.addEventListener('change', function(e) {
    if (e.target.matches('.upsell-quantity-input')) {
      const min = parseInt(e.target.getAttribute('min')) || 1;
      const max = parseInt(e.target.getAttribute('max')) || 1;
      let val = parseInt(e.target.value) || min;

      if (val < min) {
        val = min;
      } else if (val > max) {
        val = max;
      }

      e.target.value = val;
    }
  });

  // Initialize when DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Any initialization code can go here
  });

})();